<template>
    <div class="container-fluid page-card text-left">
        <div class="position-relative">
            <h3 class="card-title">Editar Arquivo</h3>
            <p class="card-subtitle">Edite as informações do arquivo</p>
            <button class="btn-delete" @click="deleteFile">
                <fa icon="fa-trash" />
            </button>
        </div>
        <hr class="page-card__divider mb-4 mb-md-6" />

        <div v-if="!isSaving">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="mb-3 mb-md-4">
                        <label class="labeld required" for="fileTitleInput"
                            >Título</label
                        >
                        <input
                            type="text"
                            id="fileTitleInput"
                            class="inputd"
                            v-model="fileData.title"
                            placeholder="Escreva um nome que chame a atenção"
                            required
                        />
                    </div>
                    <div class="mb-3 mb-md-4">
                        <label class="labeld" for="fileDescriptionInput"
                            >Descrição</label
                        >
                        <textarea
                            id="fileDescriptionInput"
                            class="inputd"
                            v-model="fileData.description"
                            placeholder="Descreva o conteúdo do arquivo"
                        ></textarea>
                    </div>
                    <div class="mb-3 mb-md-4">
                        <label class="labeld" for="fileInput">Arquivo</label>
                        <v-file-input
                            v-model="selectedFile"
                            id="fileInput"
                            accept=".pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx"
                            prependInnerIcon="mdi-paperclip"
                            :prepend-icon="false"
                            class="inputd"
                            variant="outlined"
                            density="compact"
                            @change="handleFileUpload"
                            hideDetails
                        ></v-file-input>
                        <small
                            >Formatos aceitos: PDF, Excel, Word ou
                            PowerPoint</small
                        >
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div
                        class="preview-container col-12"
                        style="position: relative"
                    >
                        <Loader v-if="isLoading" />
                        <iframe
                            v-if="filePreview && !isLoading"
                            :src="filePreview"
                            class="preview-pdf"
                            frameborder="0"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>
        <Loader v-if="isSaving" />
        <div class="button-container">
            <div class="button-container">
                <v-btn
                    variant="tonal"
                    color="grey"
                    size="large"
                    @click="$router.go(-1)"
                >
                    Cancelar
                </v-btn>
                <v-btn
                    variant="flat"
                    color="primary"
                    size="large"
                    @click="saveFile"
                >
                    Salvar
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import apiLesson from '@/utils/lesson';
    import Loader from '@/components/Loader/loader.vue';
    import apiAWS from '@/utils/storage/aws';

    export default {
        name: 'EditFile',
        components: {
            Loader,
        },
        data() {
            return {
                fileData: {
                    id: '',
                    title: '',
                    description: '',
                    path: '',
                    type: 4,
                    idModule: null,
                    idCourse: null,
                    status: 1,
                },
                filePreview: null,
                selectedFile: null,
                link: null,
                isLoading: false,
                isSaving: false,
            };
        },
        computed: {
            ...mapState(['token']),
        },
        methods: {
            async loadFileData() {
                const id = this.$route.params.slug;
                try {
                    const response = await apiLesson.getDataLessonById(
                        id,
                        this.token
                    );
                    this.fileData = response;
                    this.filePreview = this.fileData.finalPath;
                } catch (error) {
                    console.error('Erro ao carregar dados do arquivo:', error);
                }
            },
            async putFileAws(url, file) {
                try {
                    await apiAWS.putFileAWS(url, file);
                } catch (error) {
                    console.error('Erro ao enviar arquivo para AWS');
                }
            },
            async handleFileUpload(event) {
                this.isLoading = true;
                try {
                    const file = event.target.files[0];
                    const response = await apiAWS.getSignaturePdf(
                        this.token,
                        file.name
                    );
                    await this.putFileAws(response.url, file);
                    this.link = response.token;
                    this.selectedFile = file;
                    this.filePreview = URL.createObjectURL(file);
                    this.fileData.path = this.link;
                } catch (error) {
                    console.error('Erro na geração do TOKEN AWS');
                } finally {
                    this.isLoading = false;
                }
            },
            async saveFile() {
                const payload = {
                    type: 4,
                    title: this.fileData.title,
                    path: this.fileData.path,
                    description: this.fileData.description,
                    idQuiz: null,
                    idModule: this.fileData.idModule,
                    idCourse: this.fileData.idCourse,
                    status: 1,
                };
                try {
                    this.isSaving = true;
                    await apiLesson.editLesson(
                        this.token,
                        payload,
                        this.fileData.id
                    );
                    this.$router.push('/dashboard/curso');
                } catch (error) {
                    console.error('Erro ao atualizar arquivo:', error);
                } finally {
                    this.isSaving = false;
                }
            },
            async deleteFile() {
                if (confirm('Tem certeza que deseja excluir este arquivo?')) {
                    try {
                        await apiLesson.deleteLesson(
                            this.fileData.id,
                            this.token
                        );
                        this.$router.push('/dashboard/curso');
                    } catch (error) {
                        console.error('Erro ao excluir arquivo:', error);
                    }
                }
            },
        },
        created() {
            this.loadFileData();
        },
    };
</script>

<style scoped>
    .form-row {
        display: flex;
        gap: 20px;
        margin-bottom: 20px;
    }

    .form-group {
        margin-bottom: 20px;
        flex: 1;
    }

    .button-container {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
    }

    .preview-pdf {
        width: 100%;
        height: 70vh;
        border: none;
    }

    .btn-delete {
        position: absolute;
        right: 0;
        top: 0;
        border: none;
        padding: 8px 15px;
        border-radius: 4px;
        cursor: pointer;
    }

    .btn-delete:hover {
        background: #c82333;
    }
</style>
